import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { OrderService } from "../service/order.service";
import { OrderDetails } from "../model/orderDetails";
import { equipmentReceiver } from "../model/equipmentReceiver";
import { ItemService } from "../service/item.service";

@Component({
  selector: "app-equipment-sign",
  templateUrl: "./equipment-sign.component.html",
  styleUrls: ["./equipment-sign.component.css"],
})
export class EquipmentSignComponent implements OnInit {
  orderId: number;
  orderDetails: OrderDetails = {
    OrderId: 0,
    OrderLineId: 0,
    SupplierId: 0,
    OrderNumber: "",
    OrderDesc: "",
    Destination: "",
    DestinationName: "",
    CategoryNumber: "",
    CustomerId: 0,
    Price: 0,
    Quantity: 0,
    TotalPrice: 0,
    OrderDate: new Date(),
    LineNumber: 0,
    ItemName: "",
    
  };

  receiver: equipmentReceiver = {
    OrderId: 0,
    OrderNumber: "",
    OrderDesc: "",
    ItemName: "",
    SerialNumber: "",
    ReceivedDate: new Date(),
    ReceiverName: "",
    ReceiverPhoneNumber: "",
  };

  isInvalidOrder: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private itemService: ItemService
  ) {}

  ngOnInit() {
    const idParam = this.route.snapshot.paramMap.get("orderId");
    this.orderId = idParam ? +idParam : 0;

    console.log("orderId:", this.orderId);

    this.orderService.GetOrderDetailsByOrderId(this.orderId).subscribe(
      (response: OrderDetails | null) => {
        if (response) {
          this.orderDetails = response;
        } else {
          alert("הזמנה לא נימצאה במערכת");
          this.isInvalidOrder = true; // used to disable form
        }
      },
      (error) => {
        console.error("Error fetching order details", error);
        alert("Something went wrong. Please try again later.");
        this.isInvalidOrder = true;
      }
    );
  }

  submitForm = (form: NgForm) => {
    // console.log(form.value);

    this.receiver = form.value;

    this.receiver.OrderId = this.orderId;
    this.receiver.OrderNumber = this.orderDetails.OrderNumber;
    this.receiver.OrderDesc = this.orderDetails.OrderDesc;
    this.receiver.ItemName = this.orderDetails.ItemName;

    console.log(this.receiver);

    this.itemService.signEquipmentRequest(this.receiver).subscribe(
      (response) => {
        console.log(response);

        if (response) {
          alert("חתימה נעשתה בהצלחה");
        }
        form.reset();
      },
      (error) => {
        console.log(error);
        alert("משהו השתבש צרו קשר עם GoNet");
      }
    );
  };
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/equipment-sign/equipment-sign.component.ts